import { get } from './api'

const DASHBOARD_PREFIX = '/blade-portal/dashboard'

export const dashboardService = {
  /**
   * 获取客户仪表盘汇总数据
   */
  async getSummary() {
    const response = await get(`${DASHBOARD_PREFIX}/summary`)
    return response
  },

  /**
   * 获取客户统计数据
   */
  async getStats() {
    const response = await get(`${DASHBOARD_PREFIX}/stats`)
    return response
  },

  /**
   * 获取最近的报名记录
   */
  async getRecentBookings(limit = 5) {
    const response = await get(`${DASHBOARD_PREFIX}/recent-bookings`, { limit })
    return response
  },

  /**
   * 获取最近的轨迹更新
   */
  async getRecentTracking(limit = 5) {
    const response = await get(`${DASHBOARD_PREFIX}/recent-tracking`, { limit })
    return response
  },
}

export default dashboardService
